module.exports = __webpack_public_path__ + "static/fonts/CatatanPerjalanan.b082f96.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/CatatanPerjalanan.ttf
// module id = 968
// module chunks = 113